import OrbitApiV1 from '.'

class ProvisionAPI {
  static async getProvisionQueue(limit) {
    return OrbitApiV1.httpGet(`/provision?limit=${limit}`)
  }
}

export default ProvisionAPI
